// メッセージボックス_OK_CANCEL用棚
import React, { useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';

interface Props {
  label: string;
  body: JSX.Element;
  ok: string;
  okCallback: (event: React.MouseEvent) => void;
  cancel: string;
  cancelCallback: (event: React.MouseEvent) => void;
  open: boolean;
  closeCallback?: () => void;
  btn_class_name?: string;
}

const DialogConfirm: React.FC<Props> = ({
  label,
  body,
  ok,
  okCallback,
  cancel,
  cancelCallback,
  open,
  closeCallback,
  btn_class_name,
}) => {
  const handleClickOk = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    okCallback(event);
  };
  const handleClickCancel = useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      cancelCallback(event);
    },
    []
  );
  const handleClickClose = () => {
    if (typeof closeCallback !== 'undefined') {
      closeCallback();
    }
  };

  return (
    <div className="dialog-confirm">
      <div className="dialog-mask" style={{ display: open ? 'block' : 'none' }}></div>
      <div className="dialog-section" style={{ display: open ? 'block' : 'none' }}>
        <div className="dialog-inner">
          <div className="dialog-contents">
            <div
              className={`
                dialog-close
                ${typeof closeCallback === 'undefined' ? 'dialog-close-disabled' : ''}
              `}
            >
              <img src="/img/ico_012_sp.png" alt="" onClick={handleClickClose} />
            </div>
            <div className="heading-m">{label}</div>
            <div className="dialog-body">{body}</div>
            <Row className="dialog-button flex-lg-row flex-md-reverse flex-sm-column-reverse flex-column-reverse">
              <Col xl={6} lg={6} md={12} sm={12} xs={12} className="test">
                <button
                  className="c-btn btn-large btn-white btn-cancel"
                  type="button"
                  onClick={handleClickCancel}
                >
                  {cancel}
                </button>
              </Col>
              <Col xl={6} lg={6} md={12} sm={12} xs={12} className="test">
                <button
                  className={`c-btn btn-large btn-green btn-ok mr-0 ml-auto ${btn_class_name}`}
                  type="button"
                  onClick={handleClickOk}
                >
                  {ok}
                </button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DialogConfirm;
